// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer, Row, Col } from "@components";
import type { Rows } from "@components/columns-container/types";

type Props = $Exact<{
  data: Object,
  ...PropsFromLocalize,
}>;

export class RtwNotificationsView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("RETURN_TO_WORK_MANAGER_INSTRUCTIONS"),
                (this.props.data || {}).managerInstructions,
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("RETURN_TO_WORK_OVERDUE_RTW_INSTRUCTIONS"),
                (this.props.data || {}).overdueRtwInstructions,
              ],
            ],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(RtwNotificationsView);
